module.exports = __webpack_public_path__ + "img/stire-recenta.efe34b97.png";